module.exports = __webpack_public_path__ + "static/media/karafs.3beea7e7.png";